import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaCheck, FaCopy, FaTimes } from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-select-class-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 720px;
  }
  .mdl-select-class-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-select-class-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-select-class-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-select-class-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-select-class-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-select-class-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .msc-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .msc-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .msc-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .msc-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .msc-hint {
    margin: 0 0 10px;
    font-size: 12px;
    font-weight: 600;
    color: #607d8b;
  }
  .msc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 8px;
    max-height: 360px;
    overflow-y: auto;
    padding: 2px;
  }
  .msc-card {
    display: flex;
    flex-direction: column;
    gap: 6px;
    text-align: left;
    padding: 12px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
    cursor: pointer;
    color: #455a64;
  }
  .msc-card:hover {
    border-color: #4fc3f7;
    background: #f0f9ff;
  }
  .msc-card.is-active {
    border-color: #0288d1;
    background: #e1f5fe;
    box-shadow: 0 2px 8px rgba(2, 136, 209, 0.1);
  }
  .msc-card__name {
    font-size: 13px;
    font-weight: 800;
    color: #01579b;
  }
  .msc-card__meta {
    font-size: 11px;
    font-weight: 600;
    color: #607d8b;
    line-height: 1.4;
  }
  .msc-card__badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    align-self: flex-start;
    padding: 2px 8px;
    border-radius: 999px;
    background: #0288d1;
    color: #fff;
    font-size: 10px;
    font-weight: 800;
  }
  .msc-empty,
  .msc-loading {
    text-align: center;
    padding: 28px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
    color: #607d8b;
    font-size: 13px;
    font-weight: 600;
  }
  .msc-loading__spinner {
    width: 28px;
    height: 28px;
    margin: 0 auto 10px;
    border-radius: 999px;
    border: 3px solid #b3e5fc;
    border-top-color: #0288d1;
    animation: msc-spin 0.7s linear infinite;
  }
  @keyframes msc-spin {
    to { transform: rotate(360deg); }
  }
  .msc-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .msc-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .msc-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .msc-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .msc-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
`;

//Created By Cursor
function classLabel(item) {
  if (!item) return "Class";
  if (item.section_id === "No" || !item.section_name) {
    return item.class_name || "Class";
  }
  return `${item.class_name} - ${item.section_name}`;
}

const MdlSelectClass = ({
  isOpen,
  onClose,
  onSelect,
  exam_id,
  session_id,
  current_class_id,
  current_section_id,
  copyType = "papers",
}) => {
  const [loading, setLoading] = useState(false);
  const [classList, setClassList] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [copying, setCopying] = useState(false);

  useEffect(() => {
    if (!isOpen) return undefined;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-select-class", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, [isOpen]);

  //Created By Cursor
  const checkClassesForDateSheets = useCallback(
    async (classes) => {
      const schoolCode = SessionManager.getSchoolCode();
      try {
        const results = await Promise.all(
          classes.map(async (classItem) => {
            const response = await axios.get(
              `${API_BASE()}getExamDateSheet.php`,
              {
                params: {
                  school_code: schoolCode,
                  exam_id,
                  session_id,
                  class_id: classItem.class_id,
                  section_id: classItem.section_id,
                },
              }
            );
            const dateSheetCount =
              response.data?.api_status === "OK" && response.data.data
                ? response.data.data.length
                : 0;
            return { classItem, dateSheetCount };
          })
        );
        setClassList(
          results
            .filter((result) => result.dateSheetCount > 0)
            .map((result) => ({
              ...result.classItem,
              dateSheetCount: result.dateSheetCount,
            }))
        );
      } catch (error) {
        setClassList([]);
      }
    },
    [exam_id, session_id]
  );

  //Created By Cursor
  const getAvailableClasses = useCallback(async () => {
    setLoading(true);
    setSelectedClass(null);
    try {
      const response = await axios.get(
        `${API_BASE()}getClassWithSubjectsPartAndPaper.php`,
        {
          params: {
            school_code: SessionManager.getSchoolCode(),
            exam_id,
            session_id,
          },
        }
      );

      if (response.data?.api_status === "OK") {
        const filteredClasses = (response.data.data || []).filter(
          (classItem) =>
            !(
              String(classItem.class_id) === String(current_class_id) &&
              String(classItem.section_id) === String(current_section_id)
            )
        );

        if (copyType === "datesheets") {
          await checkClassesForDateSheets(filteredClasses);
        } else {
          setClassList(
            filteredClasses.filter(
              (classItem) => (classItem.subject_paper || []).length > 0
            )
          );
        }
      } else {
        setClassList([]);
        myToast.notify_warning(response.data?.api_remark);
      }
    } catch (error) {
      setClassList([]);
    } finally {
      setLoading(false);
    }
  }, [
    checkClassesForDateSheets,
    copyType,
    current_class_id,
    current_section_id,
    exam_id,
    session_id,
  ]);

  useEffect(() => {
    if (isOpen) getAvailableClasses();
  }, [isOpen, getAvailableClasses]);

  //Created By Cursor
  const copyDateSheetsFromClass = useCallback(
    async (sourceClass) => {
      const response = await axios.get(
        `${API_BASE()}copyDateSheetFromClass.php`,
        {
          params: {
            staff_id: SessionManager.getStaffDetails()?.staff_id,
            exam_id,
            target_class_id: current_class_id,
            target_section_id: current_section_id,
            source_class_id: sourceClass.class_id,
            source_section_id: sourceClass.section_id,
            session_id,
            school_code: SessionManager.getSchoolCode(),
          },
        }
      );

      if (
        response.data?.api_status === "OK" ||
        response.data?.api_status === "WARNING"
      ) {
        if (response.data.api_status === "OK") {
          myToast.notify_success(response.data.api_remark);
        } else {
          myToast.notify_warning(response.data.api_remark);
        }
        onSelect(sourceClass);
        onClose();
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to copy date sheets"
        );
      }
    },
    [
      current_class_id,
      current_section_id,
      exam_id,
      onClose,
      onSelect,
      session_id,
    ]
  );

  //Created By Cursor
  const copyPapersFromClass = useCallback(
    async (sourceClass) => {
      const response = await axios.get(`${API_BASE()}copyPapersFromClass.php`, {
        params: {
          staff_id: SessionManager.getStaffDetails()?.staff_id,
          exam_id,
          target_class_id: current_class_id,
          target_section_id: current_section_id,
          source_class_id: sourceClass.class_id,
          source_section_id: sourceClass.section_id,
          session_id,
          school_code: SessionManager.getSchoolCode(),
        },
      });

      if (
        response.data?.api_status === "OK" ||
        response.data?.api_status === "WARNING"
      ) {
        if (response.data.api_status === "OK") {
          myToast.notify_success(response.data.api_remark);
        } else {
          myToast.notify_warning(response.data.api_remark);
        }
        onSelect(sourceClass);
        onClose();
      } else {
        myToast.notify_error(
          response.data?.api_remark || "Failed to copy papers"
        );
      }
    },
    [
      current_class_id,
      current_section_id,
      exam_id,
      onClose,
      onSelect,
      session_id,
    ]
  );

  //Created By Cursor
  const handleConfirm = useCallback(async () => {
    if (!selectedClass) {
      myToast.notify_warning(
        `Please select a class to copy ${
          copyType === "datesheets" ? "date sheets" : "papers"
        } from`
      );
      return;
    }

    setCopying(true);
    try {
      if (copyType === "datesheets") {
        await copyDateSheetsFromClass(selectedClass);
      } else {
        await copyPapersFromClass(selectedClass);
      }
    } catch (error) {
      myToast.notify_error(
        `Failed to copy ${copyType}. Please try again.`
      );
    } finally {
      setCopying(false);
    }
  }, [
    copyDateSheetsFromClass,
    copyPapersFromClass,
    copyType,
    selectedClass,
  ]);

  if (!isOpen) return null;

  const itemLabel = copyType === "datesheets" ? "Date Sheets" : "Papers";
  const busy = loading || copying;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      animation={false}
      centered
      dialogClassName="mdl-select-class-dialog"
      aria-labelledby="mdl-select-class-title"
    >
      <Modal.Header closeButton={!busy}>
        <div className="msc-title" id="mdl-select-class-title">
          <span className="msc-title__icon" aria-hidden>
            <FaCopy />
          </span>
          <div>
            <div className="msc-title__main">Copy {itemLabel}</div>
            <div className="msc-title__sub">
              Select a class to copy {itemLabel.toLowerCase()} from
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <p className="msc-hint">
          Choose a source class. Current class is excluded.
        </p>

        {loading ? (
          <div className="msc-loading">
            <div className="msc-loading__spinner" aria-hidden />
            Loading available classes…
          </div>
        ) : classList.length === 0 ? (
          <div className="msc-empty">
            No other classes have {itemLabel.toLowerCase()} available to copy.
          </div>
        ) : (
          <div className="msc-grid">
            {classList.map((classItem, index) => {
              const active =
                selectedClass &&
                String(selectedClass.class_id) === String(classItem.class_id) &&
                String(selectedClass.section_id) ===
                  String(classItem.section_id);

              return (
                <button
                  key={`${classItem.class_id}-${classItem.section_id}-${index}`}
                  type="button"
                  className={`msc-card${active ? " is-active" : ""}`}
                  onClick={() => setSelectedClass(classItem)}
                  disabled={busy}
                >
                  <span className="msc-card__name">
                    {classLabel(classItem)}
                  </span>
                  <span className="msc-card__meta">
                    {copyType === "datesheets" ? (
                      <>
                        Date Sheets: {classItem.dateSheetCount || 0}
                        <br />
                        Subjects: {classItem.subject?.length || 0}
                      </>
                    ) : (
                      <>
                        Papers: {classItem.subject_paper?.length || 0}
                        <br />
                        Subjects: {classItem.subject?.length || 0}
                      </>
                    )}
                  </span>
                  {active ? (
                    <span className="msc-card__badge">
                      <FaCheck aria-hidden /> Selected
                    </span>
                  ) : null}
                </button>
              );
            })}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="msc-btn msc-btn--ghost"
          onClick={onClose}
          disabled={busy}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="msc-btn msc-btn--primary"
          onClick={handleConfirm}
          disabled={!selectedClass || busy}
        >
          <FaCopy aria-hidden />
          {copying ? "Copying…" : `Copy ${itemLabel}`}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlSelectClass;
